import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { buildLink } from '@caritas/ui';

import { useQueryParams } from '../commons/query-string';
import { currentTheme } from './theme';

const siteSpecificLocales = {
  bergeinsatz: ['de', 'fr', 'it'],
  caritascare: ['de'],
  caritas: ['de', 'fr', 'it', 'en'],
  youngcaritas: ['de'],
};

export const coreLanguages = siteSpecificLocales[currentTheme];

export function languageFallback(
  locale: string,
): (typeof coreLanguages)[number] {
  return coreLanguages.includes(locale) ? locale : 'en';
}

// Core languages have to appear always in the language switcher, but
// should link to the home page in the given language.
const coreLocalizations: Array<{ locale: string; path: string }> =
  coreLanguages.map((lang) => ({ locale: lang, path: `/${lang}` }));

export const mapPageLocalizations = (pageContext: SilverbackPageContext) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const urlQuery = useQueryParams();

  return [...coreLocalizations, ...pageContext.localizations!]
    .map((item) => {
      return {
        [item.locale]: buildLink({
          href: item.path,
          target: '_self',
          query: urlQuery,
        }),
      };
    })
    .reduce((acc, val) => ({ ...acc, ...val }));
};
